var touch = false, clickEv = 'click';

/* slider blog*/
function sliderBlog(){
  /* Slider Related */
  if($(".blog-related").length){
    $('.blog-related').slick({
      dots: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: 1260,
          settings: {
            slidesToScroll: 2,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToScroll: 2,
            slidesToShow: 2
          }
        }
      ]
    });
  }
}
/* slider product*/
function slider_product(){
  /* Slider Vertical */
  if($("#gallery-images-vertical .vertical-slider").length){
    $('#gallery-images-vertical .vertical-slider').slick({
      dots: false,
      vertical: true,
      verticalSwiping: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1260,
          settings: {
            slidesToScroll: 4,
            slidesToShow: 4
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToScroll: 4,
            slidesToShow: 4
          }
        }
      ]
    });
  }
  /* Slider Thumb */
  if($("#gallery-images .horizontal-slider").length){
    $("#gallery-images .horizontal-slider").slick({
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1260,
          settings: {
            slidesToScroll: 4,
            slidesToShow: 4
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToScroll: 3,
            slidesToShow: 3
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToScroll:2,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 320,
          settings: {
            slidesToScroll:2,
            slidesToShow: 2
          }
        }
      ]
    });
  }
  /* Slider Related */
  if($(".rp-slider").length){
    $(".rp-slider").slick({
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToScroll: 3,
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToScroll:2,
            slidesToShow: 2
          }
        }
      ]
    });
  }
  /* Slider prodMore */
  if($(".prodMore-slider").length){
    $(".prodMore-slider").slick({
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToScroll: 3,
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToScroll:2,
            slidesToShow: 2
          }
        }
      ]
    });
  }
  /* Slider prodMenu */
  if($(".subMenu-productCarousel").length){
    $(".subMenu-productCarousel").owlCarousel({
      navigation : true,
      pagination: false,
      items: 2,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1199,2],
      itemsDesktopSmall : [979,2],
      itemsTablet: [768,2],
      itemsTabletSmall: [540,1],
      itemsMobile : [360,1],
      navigationText: ['<i class="fa fa-angle-left" title="Previous"></i>', '<i class="fa fa-angle-right" title="Next"></i>']
    });
  }
  /* Slider homeMenu */
  if($(".megaMenu-1-allHome").length){
    $(".megaMenu-1-allHome").owlCarousel({
      autoPlay: 3000,
      itemsScaleUp: 4,
      navigation : true,
      pagination: false,
      items: 4,
      slideBy: 4,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1199,4],
      itemsDesktopSmall : [979,3],
      itemsTablet: [768,3],
      itemsTabletSmall: [540,2],
      itemsMobile : [360,2],
      navigationText: ['<i class="fa fa-angle-left" title="Previous"></i>', '<i class="fa fa-angle-right" title="Next"></i>']
    });
  }
}

/* Handle dropdown box */
function handleDropdown(){
  if($('.dropdown-toggle').length){
    $('.dropdown-toggle').parent().hover(function (){
      if(touch == false && getWidthBrowser() > 767 ){
        $(this).find('.dropdown-menu').stop(true, true).slideDown(300);
      }
    }, function (){
      if(touch == false && getWidthBrowser() > 767 ){
        $(this).find('.dropdown-menu').hide();
      }
    });
  }
  
  $('.dropdown').on('click', function() {
    if(touch == false && getWidthBrowser() > 767 ){
      var href = $(this).find('.dropdown-link').attr('href');
      window.location = href;
    }
  });

  $('.cart-link').on('click', function() {
    if(touch == false && getWidthBrowser() > 767 ){
      var href = $(this).find('.dropdown-link').attr('href');
      window.location = href;
    }
  });

}

/* Fucntion get width browser */
function getWidthBrowser() {
  var myWidth;

  if( typeof( window.innerWidth ) == 'number' ) { 
    //Non-IE 
    myWidth = window.innerWidth;
    //myHeight = window.innerHeight; 
  } 
  else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { 
    //IE 6+ in 'standards compliant mode' 
    myWidth = document.documentElement.clientWidth; 
    //myHeight = document.documentElement.clientHeight; 
  } 
  else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { 
    //IE 4 compatible 
    myWidth = document.body.clientWidth; 
    //myHeight = document.body.clientHeight; 
  }

  return myWidth;
}

// handle scroll-to-top button
function handleScrollTop() {
  function totop_button(a) {
    var b = $("#scroll-to-top"),
        f = $(".cart-float-right");

    if (a == "on") { 
      f.addClass("on fadeInRight ").removeClass("off fadeOutRight");
      b.addClass("on fadeInRight ").removeClass("off fadeOutRight"); 
    } else {
      f.addClass("off fadeOutRight animated").removeClass("on fadeInRight");
      b.addClass("off fadeOutRight animated").removeClass("on fadeInRight"); 
    }
  }
  $(window).scroll(function() {
    var b = $(this).scrollTop();
    var c = $(this).height();
    if (b > 0) { 
      var d = b + c / 2;
    } 
    else { 
      var d = 1 ;
    }    
    if (d < 1e3 && d < c) { 
      totop_button("off");
    } 
    else {
      totop_button("on"); 
    }
  });  
  $("#scroll-to-top").click(function (e) {
    e.preventDefault();
    $('body,html').animate({scrollTop:0},800,'swing');
  });
}   

//newsletter popup
function ModalNewsletter(){
  
}

function checkcookie(){
  $.cookie('mello-cookie', 'deactive', { expires: 10});
}

/* Handle product quantity */
function handleQuantity(){
  if($('.quantity-wrapper').length){
    $('.quantity-wrapper').on(clickEv, '.qty-up', function() {
      var $this = $(this);

      var qty = $this.data('src');
      $(qty).val(parseInt($(qty).val()) + 1);
    });
    $('.quantity-wrapper').on(clickEv, '.qty-down', function() {
      var $this = $(this);
      var qty = $this.data('src');

      if(parseInt($(qty).val()) > 1)
        $(qty).val(parseInt($(qty).val()) - 1);
    });
  }
}
function colorwarches(){
  jQuery('.swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
  }); 
}



function toggleTagsFilter(){ 
  var tagsbutton = document.getElementById( 'showTagsFilter' ),    
      tagscontent = document.getElementById( 'filters_content' );    
  if(tagsbutton != null ){
    tagsbutton.onclick = function() {
      classie.toggle( this, 'closed' );
      classie.toggle( tagscontent, 'tags-closed' );
      if(classie.has( this, 'closed' ))
        $('#showTagsFilter').html("Translation missing: en.bridal.collection.filter <i class='fa fa-angle-down'></i>");
      else $('#showTagsFilter').html("Translation missing: en.bridal.collection.filter <i class='fa fa-angle-up'></i>");
      };
  }
}

// handle scroll-to-down button
function handleScrollDown() {
  $(".scroll-to-down").click(function() {
    $('html, body').animate({scrollTop: $(this).offset().top}, 1000);
    return false;
  });
}                                       

function toggleLeftMenu(){
  var showLeftPush = document.getElementById( 'showLeftPush' );	
  showLeftPush.onclick = function() {
    $('.moTab-navigation').addClass('active');
  };
  var closeLeftPush = document.getElementById( 'closeLeftPush' );	
  closeLeftPush.onclick = function() {
    $('.moTab-navigation').removeClass('active');
  };
};

/* Function update scroll product thumbs */
function updateScrollThumbsQS(){
  if($('#gallery_main_qs').length){

    $('#quick-shop-image .fancybox').on(clickEv, function() {
      var _items = [];
      var _index = 0;
      var product_images = $('#gallery_main_qs .image-thumb');
      product_images.each(function(key, val) {
        _items.push({'href' : val.href, 'title' : val.title});
        if($(this).hasClass('active')){
          _index = key;
        }
      });
      $.fancybox(_items,{
        closeBtn: true,
        index: _index,
        helpers: {
          buttons: {}
        }
      });
      return false;
    });

    $('#quick-shop-image').on(clickEv, '.image-thumb', function() {

      var $this = $(this);
      var background = $('.product-image .main-image .main-image-bg');
      var parent = $this.parents('.product-image-wrapper');
      var src_original = $this.attr('data-image-zoom');
      var src_display = $this.attr('data-image');

      background.show();

      parent.find('.image-thumb').removeClass('active');
      $this.addClass('active');

      parent.find('.main-image').find('img').attr('data-zoom-image', src_original);
      parent.find('.main-image').find('img').attr('src', src_display).load(function() {
        background.hide();
      });

      return false;
    });
  }
}

//Change Quantity Quick Show
function change_qs_quantity(qs){
  qs_quantity=qs;
}

function showMenuMobile(){
  $('.navigation_mobile .arrow').click(function(){
    if($(this).attr('class')=='arrow class_test'){
      $('.navigation_mobile .arrow').removeClass('class_test');
      $('.navigation_mobile').removeClass('active');
      $('.navigation_mobile').find('.menu-mobile-container').hide("slow");
    }
    else{
      $('.navigation_mobile .arrow').removeClass('class_test');
      $(this).addClass('class_test');
      $('.navigation_mobile').each(function(){
        if($(this).find('.arrow').attr('class')=='arrow class_test'){
          $(this).find('.menu-mobile-container').show( "slow" );
          $(this).addClass('active');
        }
        else{
          $(this).find('.menu-mobile-container').hide("slow");
          $(this).removeClass('active');
        }
      });
    }
  });
}

function showSideMenu(){
  if(window.innerWidth > 767 ){
    $(".navigation_links_left li").hover(
      function() {
        $(this).addClass('hover');
        if($(this).hasClass('hot_deals')){
          $("#hot_deals").addClass('hover');
          $(".home_slideshow .home_sidemenu_inner").addClass('hover');
        }
        else if($(this).hasClass('mobile_phone___tablet')){
          $("#mobile_phone___tablet").addClass('hover');
          $(".home_slideshow .home_sidemenu_inner").addClass('hover');
        }
        else if($(this).hasClass('foods')){
          $("#foods").addClass('hover');
          $(".home_slideshow .home_sidemenu_inner").addClass('hover');
        }
      }, function() {
        $(this).removeClass('hover');
        $(".home_sidemenu_inner .sidemenu_content").removeClass('hover');
        $(".home_slideshow .home_sidemenu_inner").removeClass('hover');
      }
    );
    $(".home_sidemenu_inner .sidemenu_content").hover(
      function() {
        $(this).addClass('hover');
        if($(this).attr('id') == 'hot_deals'){
          $(".navigation_links_left li.hot_deals").addClass('hover');
          $(".home_slideshow .home_sidemenu_inner").addClass('hover');
        }
        else if($(this).attr('id') == 'mobile_phone___tablet'){
          $(".navigation_links_left li.mobile_phone___tablet").addClass('hover');
          $(".home_slideshow .home_sidemenu_inner").addClass('hover');
        }
        else if($(this).attr('id') == 'foods'){
          $(".navigation_links_left li.foods").addClass('hover');
          $(".home_slideshow .home_sidemenu_inner").addClass('hover');
        }
      }, function() {
        $(".home_sidemenu_inner .sidemenu_content").removeClass('hover');
        $(".navigation_links_left li").removeClass('hover');
        $(".home_slideshow .home_sidemenu_inner").removeClass('hover');
      }
    );
  }
}

function addColorTitle(){
  var i=0;
  var j=0;
  $( ".index-section-product" ).each(function( index ) {
    i++;
    if(i%4==0){
      $(this).find('.home_products_top .line-title').css( "background-color","#ab47bc" );
    }
    else if(i%4==1){
      $(this).find('.home_products_top .line-title').css( "background-color","#26c6da" );
    }
    else if(i%4==2){
      $(this).find('.home_products_top .line-title').css( "background-color","#cddc39" );
    }
    else if(i%4==3){
      $(this).find('.home_products_top .line-title').css( "background-color","#ec407a" );
    }
  });
  
  $( ".index-section-service .home_service_item_group" ).each(function( index ) {
    i++;
    if(i%4==0){
      $(this).find('.home_service_top .line-title').css( "background-color","#ffc107" );
    }
    else if(i%4==1){
      $(this).find('.home_service_top .line-title').css( "background-color","#1e88e5" );
    }
    else if(i%4==2){
      $(this).find('.home_service_top .line-title').css( "background-color","#3f51b5" );
    }
    else if(i%4==3){
      $(this).find('.home_service_top .line-title').css( "background-color","#e53935" );
    }
  });
}

function showIconMobile(){
  var showSearch = function(){
    $(".navSearch-mobile-item .search-icon").on("click", function() {
      $(this).parent().find(".search-content").addClass("active-search");
    });
  }
  var hideSearch = function(){
    $(".navSearch-mobile-item .search-hide").on("click", function() {
      $(this).parents(".search-content").removeClass("active-search");
      if(getWidthBrowser() < 992){
        if($(this).data('search') == 'active'){
          window.location.href = "/";
        }
      }
    });
  }
  showSearch();
  hideSearch();
}

function focusSearch(){
  $('.search-header__input').add('.search-header__submit').on('focus blur', function() {
    $('.search-header').toggleClass('search--focus');
  });
}

function handleGridList(){
  var clickList = function(){
    if($('#goList').length){
      $('#goList').on(clickEv, function(e){
        $(this).parent().find('li').removeClass('active');
        $(this).addClass('active');
        $('.collection-items').addClass('full-width ListMode');
        $('.collection-items').removeClass('no_full-width GridMode');
        $('.collection-items .row-left').addClass('col-md-5');
        $('.collection-items .row-right').addClass('col-md-7');
        $('.collection-items .product-item').attr('class','product-item');
        $('.grid-mode').addClass("hide");
        $('.list-mode').removeClass("hide");
      });
    }
  }
  var clickGrid = function(){
    if($('.grid_list .goGrid').length){
      $('.grid_list .goGrid').on(clickEv, function(e){
        var grid = $(this).data('option-value');
        var col = 'col-sm-'+$(this).data('col')+' col-'+$(this).data('col');
        $.cookie('collecCol-cookie', col);
        $.cookie('collecGrid-cookie', grid);
        loadGrid(col,grid);
      });
    }
  }
  var loadGrid = function(col,grid){
    $('.collection-items').removeClass('full-width ListMode');
    $('.collection-items').addClass('no_full-width GridMode');
    $('.collection-items .row-left').removeClass('col-md-5');
    $('.collection-items .row-right').removeClass('col-md-7');
    $('.grid-mode').removeClass("hide");
    $('.list-mode').addClass("hide");
    $('.collection-items .product-item').attr('class','product-item '+col);
    $('.grid_list').find('li').removeClass('active');
    $('.grid_list').find('[data-option-value="'+grid+'"]').addClass('active');
  }
  var loadCookie = function(){
    if($.cookie('collecCol-cookie') != null && $.cookie('collecGrid-cookie') != null ){
      loadGrid($.cookie('collecCol-cookie'),$.cookie('collecGrid-cookie'));
    }
  }
  clickGrid();
  loadCookie();
  if(getWidthBrowser() < 768){
    if($.cookie('collecGrid-cookie') != null && $.cookie('collecGrid-cookie') > 2){
      loadGrid('col-sm-6 col-2',2);
    }
  }
  else{
  	clickList();
    if($.cookie('collecGrid-cookie') != null && $.cookie('collecGrid-cookie') < 2){
      loadGrid('col-sm-4 col-3',3);
    }
  }
}

function tagFilterCollection(){
  var newQuery = '';
  var init = function(){
    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
  }
  var showClearAll = function(){
    if (Shopify.queryParams.constraint) {
      $('.collection-leftsidebar .sidebarMobile-clear').css('display','block');
    }
    else{
      $('.collection-leftsidebar .sidebarMobile-clear').css('display','none');
    }
  }
  var createUrl = function(url,queryParams){
    history.pushState({
      param: queryParams
    }, url, url);
    $.ajax({
      type: 'GET',
      url: url,
      data: {},
      beforeSend: function( xhr ) {
        $("#tags-load").show();
      },
      complete: function (data) {  
        $('#collection').html($("#collection", data.responseText).html());      
        $("#tags-load").hide();
        var urls = "\/\/productreviews.shopifycdn.com\/assets\/v4\/spr.js?shop=";
        $.getScript(urls, function() {
        });
        showClearAll();
        handleGridList();
        toggleTagsFilter();
        $(GLOBAL['common']['init']);
        filterClick();
        activeFilterMobile();
        closeFilterMobile();
        clearFilterMobile();
        applyFilterMobile();
        paginationCollection();
      }
    });
  }
  var filterClick = function(){
    $('.coll-filter-content ul li a').click(function(event) {
      event.preventDefault();
      var newTags = [];
      if (Shopify.queryParams.constraint) {
        newTags = Shopify.queryParams.constraint.split('+');
      }
      var dataHandle = $(this).parents('li').data("handle");
      if (dataHandle) {
        var tagCheck = newTags.indexOf(dataHandle);
        if (tagCheck >= 0) {
          newTags.splice(tagCheck, 1);
        } else {
          newTags.push(dataHandle);
        }
      }
      if (newTags.length) {
        Shopify.queryParams.constraint = newTags.join('+');
      } else {
        delete Shopify.queryParams.constraint;
      }
      delete Shopify.queryParams.page;
      newQuery = jQuery.param(Shopify.queryParams).replace(/%2B/g, '+');
      showClearAll();
      if(getWidthBrowser() > 767 ){
        var url = location.pathname + "?" + newQuery;
        createUrl(url,Shopify.queryParams);
      }
      else{
        if($(this).parents('li').hasClass('active')){
          $(this).parents('li').removeClass('active');
        }
        else{
          $(this).parents('li').addClass('active');
        }
      }
    });
  }
  var activeFilterMobile = function(){
    $('.filter-mobile .filter-title').on(clickEv, function() {
      $('#collection .collection-leftsidebar').addClass('active-sidebar');
      $('body').addClass('active-sidebarCollection');
    });
  }
  var closeFilterMobile = function(){
    $('.sidebar-top .sidebarMobile-close').on(clickEv, function() {
      $('#collection .collection-leftsidebar').removeClass('active-sidebar');
      $('body').removeClass('active-sidebarCollection');
    });
  }
  var clearFilterMobile = function(){
    $('.collection-leftsidebar .sidebarMobile-clear').on(clickEv, function() {
      var url = '/collections/all' ;
      delete Shopify.queryParams.constraint;
      createUrl(url,url);
      $('#collection .collection-leftsidebar').removeClass('active-sidebar');
      $('body').removeClass('active-sidebarCollection');
    });
  }
  var applyFilterMobile = function(){
    $('.sidebar-bottom .sidebarMobile-close').on(clickEv, function() {
      var url = location.pathname + "?" + newQuery;
      createUrl(url,Shopify.queryParam);
      $('#collection .collection-leftsidebar').removeClass('active-sidebar');
      $('body').removeClass('active-sidebarCollection');
    });
  }
  var paginationCollection = function(){
    $('.pagination-collection li a').on(clickEv, function(event) {
      event.preventDefault();
      var linkPage = $(this).attr("href").match(/page=\d+/g);
      if (linkPage) {
        Shopify.queryParams.page = parseInt(linkPage[0].match(/\d+/g));
        if (Shopify.queryParams.page) {
          newQuery = jQuery.param(Shopify.queryParams).replace(/%2B/g, '+');
		  var url = location.pathname + "?" + newQuery;
          createUrl(url,Shopify.queryParam);
        }
      }
    });
  }
  
  
  init();
  showClearAll();
  filterClick();
  activeFilterMobile();
  closeFilterMobile();
  clearFilterMobile();
  applyFilterMobile();
  paginationCollection();
}

$( window ).resize(function() {

  handleGridList();
  
  //handleDropdown();
  
});

$(window).ready(function($) {
  
  tagFilterCollection();
  
  handleGridList();
  
  focusSearch();
  
  handleScrollDown();
  
  showIconMobile();
  
  sliderBlog();

  slider_product();

  handleDropdown();

  handleScrollTop();

  colorwarches();

  $('[data-toggle="tooltip"]').tooltip();

  handleQuantity();

  //handleGridList();

  toggleTagsFilter();


  toggleLeftMenu();

  updateScrollThumbsQS();

  showMenuMobile();
  
  addColorTitle();
  
  //addClassFirst();
});


$(window).load(function() { 

  

  ModalNewsletter();
  $.cookie('mello-cookie', 'active', { expires: 10});

});